// The TVs' Centera API key ("TV dashboards" on dispatch's API Keys page):
// moves:read, drivers:read, terminals:read. It ships in this public page, so
// treat it as public.
const CENTERA_API_KEY = 'cen_8b2a007fd608226cacf654392763b8ed05e9d01086a1ec87';

export const centeraAuthHeader = { Authorization: `Bearer ${CENTERA_API_KEY}` };
